import * as React from 'react';
import * as styles from './styles.css';

import cn from 'clsx';
import { UIText1, useDeviceType, useUserBrowserTheme } from '@cian/ui-kit';

import { DESKTOP_TITLE, MOBILE_TITLE } from './content';

export const HeroBanner: React.FC<React.PropsWithChildren> = ({ children }) => {
  const isDesktop = useDeviceType() === 'desktop';
  const theme = useUserBrowserTheme();

  return (
    <div
      data-testid="HeroBanner"
      className={cn(styles['container'], theme === 'dark' ? styles['dark-bg'] : styles['light-bg'])}
    >
      <div className={styles['wrapper']}>
        <div className={styles['content']}>
          <div className={styles['heading']}>
            {isDesktop ? DESKTOP_TITLE : MOBILE_TITLE}
            {isDesktop && <UIText1 color="theme-black">Данные регулярно обновляем — заходите и будьте в курсе</UIText1>}
          </div>

          <div>{children}</div>
        </div>
      </div>
    </div>
  );
};
